import {Component, computed, input, output, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipModule} from 'primeng/tooltip';

@Component({
  selector: 'app-rating-input',
  imports: [CommonModule, TooltipModule],
  templateUrl: './rating-input.component.html',
  styleUrl: './rating-input.component.scss',
})
export class RatingInputComponent {
  readonly value = input<number | undefined>(undefined);
  readonly readOnly = input(false);
  readonly valueChange = output<number>();

  stars = [1, 2, 3, 4];
  readonly hoveredStar = signal<number | null>(null);
  readonly displayValue = computed(() => {
    if (this.readOnly()) return this.value();
    return this.hoveredStar() ?? this.value();
  });

  select(val: number) {
    if (this.readOnly()) return;
    this.valueChange.emit(val);
  }

  isStarSelected(star: number): boolean {
    const displayValue = this.displayValue();
    return displayValue != null && displayValue > 0 && displayValue >= star;
  }
}
